module.exports = __webpack_public_path__ + "static/media/portrait_curse.484b50e9.jpeg";